// main slider link whole banner
document.addEventListener('DOMContentLoaded', function() {
  var slides = document.querySelectorAll('.swiper-slide');

  slides.forEach(function(slide) {
    var button = slide.querySelector('.slideshow__shop-btn');
    if (button) {
      var link = button.getAttribute('href');
      var target = button.getAttribute('target');

      var linkWrapper = document.createElement('a');
      linkWrapper.setAttribute('href', link);
      if (target) {
        linkWrapper.setAttribute('target', target);
      }

      while (slide.firstChild) {
        linkWrapper.appendChild(slide.firstChild);
      }

      slide.appendChild(linkWrapper);
    }
  });
});


// Change Text Website
jQuery(document).ready(function() {
    jQuery("body").html(function(_, html) {
        return html.replace(/Suman Roy/g, "Zen Origin");
    });
});


// product image zoom effect
jQuery(document).ready(function () {
    // Check if the device supports touch
    const isTouchDevice = 'ontouchstart' in document.documentElement;

    // Apply zoom effect only if not a touch device
    if (!isTouchDevice) {
        jQuery(".product-main-slide-container .position-relative").on("mousemove", function (event) {
            const img = jQuery(this).closest(".product-main-slide-container").find(".image-responsive");
            const offsetX = event.offsetX;
            const offsetY = event.offsetY;
            const width = img.width();
            const height = img.height();
            const xPercent = (offsetX / width) * 100;
            const yPercent = (offsetY / height) * 100;

            img.css({
                transformOrigin: `${xPercent}% ${yPercent}%`,
                transform: "scale(2)"
            });
        });

        jQuery(".product-main-slide-container .position-relative").on("mouseleave", function () {
            const img = jQuery(this).closest(".product-main-slide-container").find(".image-responsive");
            img.css({
                transformOrigin: "center center",
                transform: "scale(1)"
            });
        });
    }
});

// Add dynamic link in map
jQuery(document).ready(function () {
    const dynamicLink = "https://maps.app.goo.gl/4xzMnrV7fJcg7rW16";
    const $mapImageDiv = jQuery('.map-image');

    if ($mapImageDiv.length) {
      $mapImageDiv.wrap(`<a href="${dynamicLink}" target="_blank"></a>`);
    }
  });

